export function useKeyDown(key: string, onKeyDown: (e: any) => void): (e: React.KeyboardEvent<HTMLInputElement>) => void {
	return (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === key) {
			onKeyDown(e);
		}
	};
}
